// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"log-view__visuallyhidden--RDyAU","focusable":"log-view__focusable--g9f_T","log-view":"log-view__log-view--mm6vk","logView":"log-view__log-view--mm6vk"};